import axios from "axios";
import { hideModal } from "./modal";

/*****************/
/* INITIAL STATE */
/*****************/
const initialState = {
  loading: false,
  error: "",
  data: [],
};

/*********/
/* TYPES */
/*********/
const FETCH_MAIL = "FETCH_MAIL";
const FETCH_MAIL_SUCCESS = "FETCH_MAIL_SUCCESS";
const FETCH_MAIL_ERROR = "FETCH_MAIL_ERROR";
const PUT_MAIL = "PUT_MAIL";
const POST_MAIL = "POST_MAIL";
const DELETE_MAIL = "DELETE_MAIL";
const FETCH_NEXT_MAIL = "FETCH_NEXT_MAIL";
const FETCH_NEXT_MAIL_SUCCESS = "FETCH_NEXT_MAIL_SUCCESS";

/*******************/
/* ACTION CREATORS */
/*******************/
export const getMails = () => async (dispatch) => {
  dispatch(loadMails());

  const response = await axios({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/mails?page=1`,
    headers: {
      "Content-Type": "application/ld+json; charset=utf-8",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  if (response.data["hydra:member"].length === 0) {
    dispatch(setError("No mails found"));
  } else {
    dispatch(setMails(response.data["hydra:member"]));
    if (
      response.data &&
      response.data["hydra:view"] &&
      response.data["hydra:view"] !== undefined &&
      response.data["hydra:view"]["hydra:next"] &&
      response.data["hydra:view"]["hydra:next"] !== undefined
    ) {
      dispatch(getNextMails(response.data["hydra:view"]["hydra:next"]));
    }
  }
};

export const getNextMails = (nextUrl) => async (dispatch) => {
  dispatch(loadNextMails());

  const response = await axios({
    method: "get",
    url: `${process.env.REACT_APP_URL}${nextUrl}`,
    headers: {
      "Content-Type": "application/ld+json; charset=utf-8",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  dispatch(setNextMails(response.data["hydra:member"]));

  if (
    response.data &&
    response.data["hydra:view"] &&
    response.data["hydra:view"] !== undefined &&
    response.data["hydra:view"]["hydra:next"] &&
    response.data["hydra:view"]["hydra:next"] !== undefined
  ) {
    dispatch(getNextMails(response.data["hydra:view"]["hydra:next"]));
  }
};

export const updateMail = (mail) => async (dispatch, getState) => {
  dispatch(putMail());
  const {
    mails: { data },
  } = getState();

  const response = await axios({
    method: "put",
    url: `${process.env.REACT_APP_URL}${mail["@id"]}`,
    headers: {
      "Content-Type": "application/ld+json; charset=utf-8",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data: mail,
  });

  if (response.status === 200) {
    const resultData = data.map((mail) => {
      if (mail["@id"] === response.data["@id"]) {
        return response.data;
      }

      return mail;
    });

    dispatch(setMails(resultData));
    dispatch(hideModal());
  } else {
    setError("Something went wrong updating");
  }
};

export const removeMail = (mail) => async (dispatch, getState) => {
  dispatch(putMail());
  const {
    mails: { data },
  } = getState();

  const response = await axios({
    method: "delete",
    url: `${process.env.REACT_APP_URL}${mail["@id"]}`,
    headers: {
      "Content-Type": "application/ld+json; charset=utf-8",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  if (response.status === 204) {
    const resultData = data.filter((x) => x["@id"] !== mail["@id"]);

    dispatch(setMails(resultData));
    dispatch(hideModal());
  } else {
    setError("Something went wrong deleting");
  }
};

export const createMail = (mail) => async (dispatch, getState) => {
  dispatch(postMail());
  const {
    mails: { data },
  } = getState();

  const response = await axios({
    method: "POST",
    url: `${process.env.REACT_APP_API_URL}/mails`,
    headers: {
      "Content-Type": "application/ld+json; charset=utf-8",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data: mail,
  });

  if (response.status === 201) {
    const resultData = [...data, ...[response.data]];

    dispatch(setMails(resultData));
    dispatch(hideModal());
  } else {
    setError("Something went wrong deleting");
  }
};

export const loadMails = () => ({ type: FETCH_MAIL });

export const putMail = () => ({ type: PUT_MAIL });

export const postMail = () => ({ type: POST_MAIL });

export const deleteMail = () => ({ type: DELETE_MAIL });

export const setMails = (mails) => ({
  type: FETCH_MAIL_SUCCESS,
  payload: { mails },
});

export const loadNextMails = (page) => ({
  type: FETCH_NEXT_MAIL,
  payload: page,
});
export const setNextMails = (mails) => ({
  type: FETCH_NEXT_MAIL_SUCCESS,
  payload: mails,
});

export const setError = (msg) => ({
  type: FETCH_MAIL_ERROR,
  payload: msg,
});

/***********/
/* REDUCER */
/***********/
const mailReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_MAIL:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case FETCH_MAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        data: payload.mails,
      };
    case PUT_MAIL:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case POST_MAIL:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case FETCH_MAIL_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case FETCH_NEXT_MAIL:
      return {
        ...state,
        error: "",
      };
    case FETCH_NEXT_MAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...state.data, ...payload],
      };
    default:
      return state;
  }
};

export default mailReducer;
